import { useCallback, useMemo, useState } from 'react';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { createChatApi } from '../api/chatApi';
import { createChatRuntime } from '../api/runtime';

/**
 * Открыть личный чат с человеком, не заходя в раздел чатов.
 * POST /chats/personal создаёт диалог или возвращает уже существующий.
 */
export const useStartPersonalChat = () => {
  const [isStarting, setIsStarting] = useState(false);

  const api = useMemo(() => {
    const runtime = createChatRuntime(LocalStorageService.getAccessTokenFromAnyStorage);
    return createChatApi(runtime);
  }, []);

  const startPersonalChat = useCallback(
    async (userId: number) => {
      setIsStarting(true);
      try {
        return await api.createPersonalChat(userId);
      } finally {
        setIsStarting(false);
      }
    },
    [api],
  );

  const startSupportChat = useCallback(async () => {
    const rawId = import.meta.env.VITE_SUPPORT_USER_ID?.trim();
    const supportUserId = Number(rawId);

    if (!rawId || !Number.isInteger(supportUserId) || supportUserId <= 0) {
      throw new Error('VITE_SUPPORT_USER_ID is not configured');
    }

    setIsStarting(true);
    try {
      return await api.createPersonalChat(supportUserId);
    } finally {
      setIsStarting(false);
    }
  }, [api]);

  return { startPersonalChat, startSupportChat, isStarting };
};
